import styled, { css, keyframes } from 'styled-components';
import { device } from '../breakpoints';
import { playGrey10, playGrey15 } from '../design-tokens';
import { getChannelLayout } from './ChannelLayout.styles';
import { getDefaultLayout } from './DefaultLayout.styles';
import { getHeaderTextLayout } from './HeaderTextLayout.styles';
import { getHeroLayout } from './HeroLayout.styles';
import { getLetterGridLayout } from './LetterGridLayout.styles';
import { getShowcaseLayout } from './Showcase.styles';
import { PlaceholderLayout } from './PlaceHolder';
import { imgPadding16By9, imgPadding2By3 } from '../PlayImage/PlayImage.styles';

const fadeAnimation = keyframes`
    0% {
        background-color: ${playGrey10};
    }

    15% {
        background-color: ${playGrey15};
    }

    30% {
        background-color: ${playGrey10};
    }

    100% {
        background-color: ${playGrey10};
    }
`;

const commonRowStyling = css`
    height: 15px;
    margin-top: 10px;
    background-color: ${playGrey10};
`;

type StyledRow1Props = {
    layout: PlaceholderLayout;
};

export const StyledRow1 = styled.div`
    background: ${playGrey10};
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: ${fadeAnimation};
    border-radius: 5px;
    padding: ${(props: StyledRow1Props) =>
        props.layout === PlaceholderLayout.PORTRAIT ? imgPadding2By3 : imgPadding16By9};
`;

export const StyledRow2 = styled.div`
    ${commonRowStyling}
    width: 80%;
`;

export const StyledRow3 = styled.div`
    ${commonRowStyling}
    width: 60%;
`;

export const StyledRow4 = styled.div`
    ${commonRowStyling}
    display: none;
`;

const getAnimationDelay = () =>
    [...new Array(12)].map(
        (item, i) => css`
            :nth-child(${i + 1}) ${StyledRow1} {
                animation-delay: ${i * 150}ms;
            }
        `
    );

export const StyledPlaceHolderItem = styled.div`
    display: inline-block;
    margin-bottom: 30px;
    width: calc(50% - 2px);

    ${getAnimationDelay()}

    @media ${device.GteXsmall} {
        width: calc(33.3% - 2px);
    }

    @media ${device.GteMedium} {
        width: calc(25% - 2px);
    }
`;

const getLayout = (layout: PlaceholderLayout) => {
    switch (layout) {
        case PlaceholderLayout.DEFAULT:
            return getDefaultLayout();
        case PlaceholderLayout.SHOWCASE:
            return getShowcaseLayout();
        case PlaceholderLayout.PORTRAIT:
            return getDefaultLayout();
        case PlaceholderLayout.COLUMN:
            return css`
                flex-direction: column;
            `;
        case PlaceholderLayout.HEADER_TEXT:
            return getHeaderTextLayout();
        case PlaceholderLayout.HERO:
            return getHeroLayout();
        case PlaceholderLayout.LETTER_GRID:
            return getLetterGridLayout();
        case PlaceholderLayout.CHANNELS:
            return getChannelLayout();
        default:
            return null;
    }
};

type StyledPlaceHolderLayout = {
    layout: PlaceholderLayout;
};

export const StyledPlaceHolder = styled.div`
    display: flex;
    width: 100%;
    overflow: hidden;
    ${(props: StyledPlaceHolderLayout) => getLayout(props.layout)};
`;
